const t = {
  OnAccountBalance: "ON_ACCOUNT_BALANCE",
  CreditVoucher: "CREDIT_VOUCHER",
  Pv: "PV",
  Bv: "BV",
  Ampoints: "AMPOINTS",
  StaffEntitlement: "STAFF_ENTITLEMENT"
}, E = {
  Credit: "CREDIT",
  Debit: "DEBIT",
  All: "ALL",
  Expire: "EXPIRE"
};
export {
  E as e,
  t as o
};
//# sourceMappingURL=EntryType-8b63ee1e.mjs.map
